<template>
  <article class='custom-call-to-action'>
    <span><h2>Custom<br>Protocol</h2></span>
    <p><strong>Can’t find what you’re looking for?</strong><br>
    Let us help you with a <a href="https://shop.opentrons.com/opentrons-custom-protocol-1-expedite-workflow/" target="_blank">custom protocol.</a></p>
  </article>
</template>

<script>
  export default {
    name: 'CalloutDocs',
  }
</script>



// WEBPACK FOOTER //
// CalloutDocs.vue?f59c609e